export const PAGE_COUNT_CACHE_MAX_AGE_MS = 24 * 60 * 60 * 1000;
/** サーバー時計がクライアントより少し遅れても、当該実行の書き込みを拾う */
export const PAGE_COUNT_RUN_CLOCK_SKEW_MS = 2_000;

export type ChildPageCountResult = {
  totalPages: number;
  discoveredCount: number;
  discoveredUrls: string[];
};

export function readPageCount(data: Record<string, unknown>): ChildPageCountResult {
  const totalPages = typeof data.totalPages === 'number' ? data.totalPages : 0;
  const discoveredUrls = Array.isArray(data.discoveredUrls)
    ? data.discoveredUrls.filter((u): u is string => typeof u === 'string' && u.length > 0)
    : [];
  const discovered = discoveredUrls.length > 0 ? discoveredUrls.length : totalPages;
  return { totalPages, discoveredCount: discovered, discoveredUrls };
}

function createdAtMs(data: Record<string, unknown>): number {
  const createdAt = data.createdAt as { toMillis?: () => number } | undefined;
  return typeof createdAt?.toMillis === 'function' ? createdAt.toMillis() : 0;
}

/** True when Firestore already has a usable page-count result. */
export function isUsablePageCount(data: Record<string, unknown>, now = Date.now()): boolean {
  if (data.reusable === false) return false;
  const result = readPageCount(data);
  if (result.totalPages <= 0 && result.discoveredCount <= 0) return false;
  const at = createdAtMs(data);
  if (!at) return true;
  return now - at < PAGE_COUNT_CACHE_MAX_AGE_MS;
}

/**
 * 当該実行が書いた結果か。再利用できない SPA 失敗でも、今回の待ちでは読む。
 * 呼び出しより十分古いドキュメントは、直後の再実行で拾わない。
 */
export function isCurrentRunPageCount(
  data: Record<string, unknown>,
  startedAt: number
): boolean {
  const at = createdAtMs(data);
  if (!at) return false;
  return at >= startedAt - PAGE_COUNT_RUN_CLOCK_SKEW_MS;
}
